import React from 'react';

type Props = {
  symbol: string;
};

const FunctionSymbol: React.FC<Props> = ({ symbol }) => (
  <span className="text-sm font-bold text-ink" data-testid="expression-symbol">
    {symbol}
  </span>
);

export default FunctionSymbol;